import React, { useState, useRef } from "react";
import smoothscroll from "smoothscroll-polyfill";
import { Song, SongCategory, SongSelectorContainer, AlbumList } from "./components";
import SpotifyIcon from "./components/SpotifyIcon.svg";
import FeaturedIcon from "./components/FeaturedIcon.svg";
import { ReactComponent as SearchIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!./components/SearchIcon.svg";
import { ReactComponent as CloseIconRaw } from "@svgr/webpack?-svgo,+titleProp,+ref!./components/CloseIcon.svg";
import { P, Input, FlexBox } from "../";
import styled from "styled-components";
import { withDefaultMedia } from "../MediaQueries";
import { useIntl, FormattedMessage } from "react-intl"; // kick off the polyfill!

smoothscroll.polyfill();
export const SingleSong = Song;
const OuterContainer = styled(FlexBox)``;
const RightContainer = styled(FlexBox)`
  flex-direction: column;
  min-width: 0;
  width: 100%;
`;
const SearchContainer = styled.div`
  margin: 0 16px 24px 16px;
  @media only screen and ${props => props.theme.media.large} {
    margin-left: 0;
    margin-right: 0;
    max-width: 396px;
  }
`;
const CloseIcon = styled(CloseIconRaw)`
  cursor: pointer;
`;
const SideImage = styled.img`
  cursor: ${props => props.cursor ? "pointer" : "default"};
  width: 160px;
  padding: 24px;
  position: sticky;
  top: 0;
`;

const SongSelectorInternal = ({
  setlist: {
    albums
  },
  value,
  onChange,
  matches,
  image,
  link
}) => {
  const {
    formatMessage
  } = useIntl();
  const [search, setSearch] = useState("");

  const handleSearch = searchTerm => {
    setSearch(searchTerm);
  };

  const albumRef = useRef({});
  const searchRef = useRef({});
  const songs = albums.reduce((accum, album) => {
    const albumSongs = album.songs.map(song => ({ ...song,
      value,
      onChange,
      album
    }));
    return accum.concat(albumSongs);
  }, []);
  const spotlightSongs = songs.filter(({
    spotlight
  }) => spotlight);
  const featuredSongs = songs.filter(({
    featured
  }) => featured);
  const popularSongs = songs.filter(({
    popular
  }) => popular);
  const comparator = new RegExp(search, "gi");
  const songResults = songs.filter(({
    name,
    album: {
      name: albumName
    }
  }) => name.match(comparator) || albumName.match(comparator));

  const captureRef = (ref, album) => {
    albumRef.current[album.id] = ref;
  };

  const handleAlbumClick = album => {
    if (!search) {//don't try to scroll when we are viewing search results
    }

    const focusRef = albumRef.current[album.id];

    if (focusRef) {
      focusRef.scrollIntoView({
        behavior: "smooth"
      });
    }
  };

  const handleFocus = () => {
    if (searchRef.current) {
      document.body.classList.add("max-search-open");

      if (!matches.large) {
        setTimeout(() => {
          searchRef.current.scrollIntoView({
            behavior: "smooth"
          });
        }, 150);
      }
    }
  };

  const handleBlur = () => {
    document.body.classList.remove("max-search-open");
  };

  return /*#__PURE__*/React.createElement(OuterContainer, null, matches.large && (image ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SideImage, {
    src: image,
    cursor: link,
    onClick: () => !!link ? window.open(link) : ""
  })) : /*#__PURE__*/React.createElement(AlbumList, {
    albums: albums,
    onAlbumClick: handleAlbumClick
  })), /*#__PURE__*/React.createElement(RightContainer, null, /*#__PURE__*/React.createElement(SearchContainer, null, /*#__PURE__*/React.createElement(Input, {
    leftIcon: /*#__PURE__*/React.createElement(SearchIcon, null),
    rightIcon: search && /*#__PURE__*/React.createElement(CloseIcon, {
      onClick: () => handleSearch("")
    }),
    placeholder: formatMessage({
      id: "label.song_search",
      defaultMessage: "Search for a song by name or album..."
    }),
    ref: searchRef,
    onFocus: handleFocus,
    onBlur: handleBlur,
    value: search,
    onChange: handleSearch,
    "data-javelin-name": `song-search-input`
  })), search ? /*#__PURE__*/React.createElement(SongSelectorContainer, null, songResults.length ? /*#__PURE__*/React.createElement(SongCategory, {
    hideHeader: true,
    songs: songResults
  }) : /*#__PURE__*/React.createElement(P, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "label.no_songs_found",
    defaultMessage: "No songs matching \u201C{search}\u201D were found. Please check your spelling or try a new search...",
    values: {
      search: /*#__PURE__*/React.createElement("b", null, search)
    }
  }))) : /*#__PURE__*/React.createElement(SongSelectorContainer, null, spotlightSongs.length > 0 && /*#__PURE__*/React.createElement(SongCategory, {
    hideHeader: true,
    songs: spotlightSongs
  }), featuredSongs.length > 0 && /*#__PURE__*/React.createElement(SongCategory, {
    name: formatMessage({
      id: "label.featured_songs ",
      defaultMessage: "Featured Songs"
    }),
    src: FeaturedIcon,
    songs: featuredSongs
  }), popularSongs.length > 0 && /*#__PURE__*/React.createElement(SongCategory, {
    name: formatMessage({
      id: "label.popular_songs",
      defaultMessage: "Popular on Spotify"
    }),
    src: SpotifyIcon,
    songs: popularSongs
  }), albums.map(album => /*#__PURE__*/React.createElement(SongCategory, {
    key: album.id,
    name: album.name,
    containerRef: ref => captureRef(ref, album),
    src: !!album.image ? album.image : !!album.images && album.images.length > 0 ? album.images[0].url : null,
    songs: songs.filter(({
      album: songAlbum
    }) => album === songAlbum)
  })))));
};

export const SongSelector = withDefaultMedia(SongSelectorInternal);